export default {
    INIT: 'init',
    LOADED: 'loaded',
    CLOSE: 'close',
    RESIZE: 'resize',
    SUCCEED: 'success',
};
